import axios from "axios";
import constants from "../configs/constants";

export const fetcher = axios.create({
  baseURL: constants.API_URL,
});
